import React, { useState, useMemo } from 'react';
import CreatableSelect from 'react-select/creatable';
import styles from './selectStyles';

const createOption = label => ({
  label,
  value: label
});

const components = {
  DropdownIndicator: null
};

const TagInput = ({ value, setValue }) => {
  const [inputValue, setInputValue] = useState('');

  const displayValues = useMemo(() => {
    if (!value) return [];
    return value.map(v => createOption(String(v)));
  }, [value]);

  const updateValue = newValue => {
    setValue((newValue || []).filter(v => !Number.isNaN(v)));
  };

  const handleKeyDown = event => {
    if (!inputValue) return;
    switch (event.key) {
      case 'Enter':
      case ' ':
      case 'Tab': {
        updateValue([...value, inputValue]);
        setInputValue('');
        event.preventDefault();
      }
    }
  };

  return (
    <CreatableSelect
      components={components}
      inputValue={inputValue}
      isClearable
      isMulti
      styles={styles}
      menuIsOpen={false}
      onChange={newValue => updateValue(newValue.map(v => v.value))}
      onInputChange={newValue => setInputValue(newValue)}
      onKeyDown={handleKeyDown}
      placeholder="Type something and press enter..."
      value={displayValues}
    />
  );
};

export default TagInput;
